import React, { useEffect } from 'react';
import OwlCarousel from 'react-owl-carousel'; // Owl Carousel for React
import AOS from 'aos'; // AOS for scroll animations
import 'aos/dist/aos.css'; // AOS styles


const Slider = () => {
  // Initialize AOS animations when the component is mounted
  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <section className="hero-wrap style1">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-12">
            {/* OwlCarousel Component */}
            <OwlCarousel className="hero-img-slider owl-carousel" loop={true} items={1} autoplay={true}>
              <div className="nft-item rounded-4">
                <img src={`${process.env.PUBLIC_URL}/assets/img/slider/slider-1.jpg`} alt="Slider 1" className="rounded-4" />
              </div>
              <div className="nft-item rounded-4">
                <img src={`${process.env.PUBLIC_URL}/assets/img/slider/slider-2.jpg`} alt="Slider 2" className="rounded-4" />
              </div>
            </OwlCarousel>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Slider;
